<div class="grid  md:grid-cols-3">
  <div class="md:col-span-2">
    <P class="text-muted text-base">رزرو آنلاین بیش از 2500 واحد اقامتی در سراسر ایران</P>
    <div class="grid  grid-cols-3 mt-5">
      <div class="md:col-auto text-center md:text-right">
        <p class="text-black-300 font-bold text-base">مشتریان ما</p>
        <p class="text-blue-500 font-bold mt-3 md:text-4xl text-xl">4384394</p>
      </div>
      <div class="md:col-auto text-center md:text-right">
        <p class="text-black-300 font-bold text-base">هتل های فعال</p>
        <p class="text-blue-500 font-bold mt-3  md:text-4xl text-xl">3026</p>
      </div>
      <div class="md:col-auto text-center md:text-right">
        <p class="text-black-300 font-bold text-base">نظرات واقعی</p>
        <p class="text-blue-500 font-bold mt-3  md:text-4xl text-xl">562644</p>
      </div>
    </div>
    <div>
      <ul class="grid lg:grid-cols-4 md:grid-cols-3 grid-cols-2 gap-4 mt-5 list-disc list-inside">
        <li class="md:col-auto text-black-500 text-base text-center md:text-right">
          <a href="/kish-hotels/">
            <span>هتل های کیش</span>
          </a>
        </li>
        <li class="md:col-auto  text-black-500 text-base text-center md:text-right">
          <a href="/tehran-hotels/">
            <span>هتل های تهران</span>
          </a>
        </li>
        <li class="md:col-auto  text-black-500 text-base text-center md:text-right">
          <a href="/mashhad-hotels/">
            <span>هتل های مشهد</span>
          </a>
        </li>
        <li class="md:col-auto text-black-500 text-base text-center md:text-right">
          <a href="/isfahan-hotels/">
            <span>هتل های اصفهان</span>
          </a>
        </li>
        <li class="md:col-auto  text-black-500 text-base text-center md:text-right">
          <a href="/shiraz-hotels/">
            <span>هتل های شیراز</span>
          </a>
        </li>
        <li class="md:col-auto  text-black-500 text-base text-center md:text-right">
          <a href="/qeshm-hotels/">
            <span>هتل های قشم</span>
          </a>
        </li>
        <li class="md:col-auto  text-black-500 text-base text-center md:text-right">
          <a href="/yazd-hotels/">
            <span>هتل های یزد</span>
          </a>
        </li>
        <li class="md:col-auto  text-black-500 text-base text-center md:text-right">
          <a href="/tabriz-hotels/">
            <span>هتل های تبریز</span>
          </a>
        </li>
      </ul>

    </div>

  </div>
  <div class="hidden md:col-span-1 md:flex justify-center md:justify-end my-5 md:my-0 text-center">
    <img [ngSrc]="cdnUrl + '/images/iho-iran.png'" height="408" width="400" alt="تصویر نقشه هتل های فعال ایران">
  </div>

</div>
<div class="w-full float-right">

  <div class="main-section-wrapper mt-16">
    <div class="w-full flex justify-between items-center">
      <h2 class="text-2xl font-bold">هتل های زنجیره‌ای</h2>

      <a href="https://www.iranhotelonline.com/residency/" title="مشاهده همه ی هتل های زنجیره ای" mat-button
        color="primary" class="text-blue-500 !font-bold !text-sm">مشاهده همه</a>
    </div>
    <iho-chain-hotels />
  </div>


  <h2 class="text-xl font-bold mt-16">رزرو هتل با ایران هتل آنلاین و تجربه سفری آرام</h2>
  <p class="text-muted text-xs !font-extralight leading-8 my-3">
    امروزه رزرو آنلاین هتل هنگام سفر از اهمیت به سزایی برخوردار است. ایران هتل آنلاین با هدف جلب رضایت میهمانان
    امکان رزرو هتل به صورت آنلاین را فراهم آورده است و تجربه ی سفری آرام و به دور از دغدغه های احتمالی را برای
    میهمانانی که قصد سفر به جای جای ایران را دارند، به ارمغان می‌آورد. ایران هتل آنلاین از اولین، با قدمت‌ترین و
    معتبرترین وبسایت‌های رزرو هتل در ایران است و ارائه‌دهنده بهترین تخفیفات در ایام مختلف سال به مسافران گرامی
    می‌باشد.

    هنگام رزرو آنلاین هتل با وبسایت ایران هتل آنلاین امکانات متنوعی در اختیار میهمانان گرانقدر قرار داده می‌شود.
    ایران هتل آنلاین تنها وبسایتی است که امکان جستجو هتل ها بر اساس خیابان یا مکانی خاص را به میهمان می دهد. میهمان
    با وارد کردن نام مکان یا خیابان مورد نظر خود در کادر جستجو می‌تواند تعداد هتل‌های آن منطقه را مشاهده نماید.

    گالری تصاویر، ارائه اطلاعات کامل و با جزئیات از هتل، موقعیت مکانی هر هتل، آدرس آن روی نقشه، ثبت تجربیات و نظرات
    بیش از نیم میلیون میهمان و همینطور ثبت رتبه هتل از دید آنان افق دید گسترده‌ای از هتل‌ها و مراکز اقامتی پیش روی
    افرادی که قصد رزرو هتل به صورت آنلاین را دارند، نهاده است
  </p>
  <h2 class="text-xl font-bold">رزرو آنلاین هتل ، سفر به سبکی هوشمندانه</h2>
  <p class="text-muted text-xs !font-extralight leading-8 my-3">امروزه با قرار گرفتن در عصر تکنولوژی با چند کلیک ساده
    قادر خواهیم
    بود به دنیایی از
    اطلاعات دست یابیم. رزرو هتل و برنامه‌ریزی برای اقامت و سفری دلپذیر هم از این قاعده مستثنی نیست. زمانی که بتوانیم
    پیش از سفر با مشاهده و مقایسه‌ی هتل‌های مختلف مقصدمان، با خیالی راحت انتخابی مناسب داشته باشیم دیگر تصمیم گیری
    برای محل اقامت، کار دشواری نیست.

    رزرو هتل به صورت ساده و راحت شاید به جرات بتوان گفت مهمترین عامل در لذت از سفر است. زمانی که تیم ایران هتل
    آنلاین در زمینه رزرو هتل در کنار شما باشند، این مسئله به سادگی میسر می‌شود. پشتیبانی 24 ساعته و همیشگی خدمات
    مشتریان ایران هتل آنلاین سفری راحت را برای شما رقم خواهد زد و امکان پیگیری رزرو را در هر ساعت از شبانه روز و هر
    مرحله از سفر فراهم می آورد.

    ایران هتل آنلاین با گردآوری سیستمی یکپارچه، آسان و با جستجویی دقیق، امکان رزرو هتل مطابق با خواسته و نیازهای
    میهمانان را به سادگی مهیا نموده و مراکز اقامتی متنوعی را در اختیار میهمانان قرار می دهد. با ایران هتل آنلاین در
    بیشتر شهرهای مختلف ایران می‌توان اقدام به رزرو هتل کرد؛ بنابراین با جستجو در سایت ایران هتل آنلاین برای یافتن
    مراکز اقامتی مناسب گزینه‌های زیادی پیش روی شما خواهد بود.

    برای تمامی شهرها و مقاصد شما، ایران هتل آنلاین پشنهادی مناسب و شگفت انگیز خواهد داشت. بعد از انتخاب واحد اقامتی
    مورد نظر در سایت ایران هتل آنلاین، کد پیگیری 10 رقمی به ایمیل و شماره موبایل شما ارسال می‌گردد و شما می‌توانید
    واچر را بلافاصله بعد از پرداخت وجه دریافت نمایید .</p>


  <div class="{{showCollapseInfo ? 'block' : 'hidden'}}">

    <h2 class="text-xl font-bold">رزرو هتل با تخفیف و سفری مقرون به صرفه</h2>
    <p class="text-muted text-xs !font-extralight leading-8 my-3">
      سفر مجالی برای کشف تجربیات جدید و یکی از ضروریات زندگی مدرن امروز است. گاهی رهایی از مشغله‌های روزمره با
      تجربه‌ی
      سفری آسوده میسر میگردد؛ اما یکی از موانع سفر و دغدغه‌های افرادی که کوله بار سفر می‌بندند و قصد عزیمت می
      کنند،
      هزینه‌های اقامت و رزرو هتل با تخفیف می‌باشد.

      برخی شاید اینگونه تصور کنند که یک سفر ارزان و مقرون به صرفه به معنی اقامت در مراکز اقامتی بی‌کیفیت می‌باشد؛
      ولی
      مقصدهای رویایی هم با ایران هتل آنلاین قابل دسترس شده‌اند و چنانچه رزرو هتل خود را از طریق ایران هتل آنلاین
      انجام
      دهید، با تخفیفاتی که دریافت می‌کنید، در هزینه‌های خود تغییرات قابل ملاحظه‌ای خواهید داشت.

      ایران هتل آنلاین با تضمین ارائه پایین ترین قیمت و بهترین خدمات، پیشرو در رزرو هتل و مراکز اقامتی در ایران
      می‌باشد. با رزرو آنلاین هتل در ایران هتل آنلاین، شما می‌توانید به ترتیب پرفروش ترین مراکز اقامتی و همچنین
      محدوده‌ی قیمت را تعیین کنید تا بتوانید هتلی با هزینه‌ی دلخوا‌هتان بیابید‌.

      تخفیفات فصلی و آفرهای ویژه ایران هتل آنلاین به میهمانان در زمینه رزرو هتل های ارزان، شما را شگفت زده خواهد
      کرد.
      منتظر آفرهای ایران هتل آنلاین در اعیاد و مناسبت‌های مختلف باشید و هتل های مورد علاقه خود را با کمترین قیمت
      در
      پیشنهادات لحظه آخری و پیش فروش با تخفیفات شگفت انگیز رزرو کنید.
    </p>
    <h2 class="text-xl font-bold">رزرو هتل آپارتمان</h2>
    <p class="text-muted text-xs !font-extralight leading-8 my-3">
      رزرو هتل آپارتمان در شهرهای مختلف طرفداران خاص خودش را دارد. اقامت در هتل آپارتمان بسیار شبیه ‏به اجاره
      آپارتمان است. هتل آپارتمان ها برای افرادی که به دنبال راحتی و احساسی شبیه به اقامت در منزل خود می باشند،
      بسیار مناسب است.

      برخی هتل آپارتمان ها را به مثابه خانه خود انگاشته که موقتا از محل اصلی زندگی آنها به دور است؛ بنابراین
      هرآنچه که در ‏خانه فراهم است ممکن است در هتل آپارتمان نیز فراهم باشد. همچنین فرصت اینکه همه اعضا خانواده در
      کنار هم و در یک واحد اقامت داشته باشند، بیشتر است. در برخی از هتل آپارتمان ها امکان پخت و پز نیز برای
      مهمانان فراهم می‌باشد.

      امکان رزرو اقامتگاه های بومگردی مختلف نیز با امکانات متفاوت به صورت گسترده در ایران هتل آنلاین فراهم
      می‌باشد. حس نوستالژی و آشنایی با فرهنگ و آداب و رسوم محلی در هر منطقه و حس زیستن به سبک و سیاق اصیل ایرانی
      همراه با امتحان کردن طعم غذاهای محلی باعث گردیده افراد زیادی از تمامی نقاط ایران علاقه‌مند به اقامت در
      اقامتگاه‌های بومگردی باشند.
    </p>
    <h2 class="text-xl font-bold">رزرو اینترنتی هتل با پشتیبانی 24 ساعته، هفت روز هفته</h2>
    <p class="text-muted text-xs !font-extralight leading-8 my-3">
      ایران هتل آنلاین با برخورداری از تیم پشتیبانی 24 ساعته در تمامی روزهای هفته مفتخر است تا گردشگران عزیز را در
      هر ساعت از شبانه روز برای رزرو اینترنتی هتل و انجام امور پیگیری راهنمایی نماید. اگر برای اولین بار می‌خواهید
      رزرو آنلاین هتل را انجام دهید، نیازی به نگرانی نیست. در هر مرحله از رزرو چنانچه سوالی داشتید، می‌توانید با
      شماره 02191005105 تماس حاصل فرمایید. اگر در خصوص شرایط هتل‌ها نیز سوالی دارید، باز هم می‌توانید پاسخ سوالات
      احتمالی خود را از تیم پشتیبانی ایران هتل آنلاین دریافت نمایید.
    </p>
    <h2 class="text-xl font-bold">کنسلی رزرو هتل بدون پرداخت کارمزد</h2>
    <p class="text-muted text-xs !font-extralight leading-8 my-3">
      گاه در برخی از سفرها، علیرغم تمامی برنامه‌ریزی‌های انجام شده، اتفاقاتی می‌افتد که ناچاریم برنامه سفر را به
      زمانی دیگر موکول کنیم. در این شرایط نیز ایران هتل آنلاین در کنار شماست و شما با یک تماس ساده می‌توانید
      رزرواسیون خود را به هر نقطه از ایران بدون پرداخت هیچ گونه کارمزد کنسلی، لغو نمایید.

      ایران هتل آنلاین به منظور جلب رضایت گردشگران عزیز، هیچگونه کارمزدی از میهمانان خود دریافت نمی‌کند و تنها
      جریمه هتل، متناسب با قوانینی که هتل دارد، از وجه پرداختی شما کسر می‌شود. طبیعی است که هرچه کنسل کردن
      رزرواسیون شما فاصله بیشتری از موعد سررسید داشته باشد، جریمه کمتری از شما کسر خواهد شد.
    </p>
    <h2 class="text-xl font-bold">ساده بودن فرآیند رزرو هتل داخلی از طریق ایران هتل آنلاین</h2>
    <p class="text-muted text-xs !font-extralight leading-8 my-3">
      به منظور ساده‌ سازی فرایند رزرو هتل داخلی، ایران هتل آنلاین گام‌های موثری برداشته است. طراحی و پیاده‌سازی
      فیلترهای متفاوت و جذاب باعث شده تا شما در کوتاه‌ترین زمان ممکن با اعمال این فیلترها بتوانید به سر منزل مقصود
      برسید. انتخاب هتل براساس قیمت، تعداد ستاره، موقعیت جغرافیایی، فروش، امکانات ویژه و .... تنها بخشی از خدمات
      ارزنده ایران هتل آنلاین به گردشگران عزیز در زمینه رزرو هتل های داخلی به صورت آنلاین می‌باشد.
    </p>
    <h2 class="text-xl font-bold">دریافت آنی واچر هتل با رزرو اینترنتی هتل از طریق ایران هتل آنلاین
    </h2>
    <p class="text-muted text-xs !font-extralight leading-8 my-3">
      در عصر ارتباطات و اینترنت به سر می‌بریم؛ در نتیجه توقع داریم تا در کوتاه‌ترین زمان ممکن، به هر آنچه
      می‌خواهیم دسترسی داشته باشیم. دریافت واچر هتل (رسید پرداخت و تاییدیه هتل)، بلافاصله بعد از انتخاب هتل و
      پرداخت وجه، خیال ما را از هر نظر راحت می‌کند.

      شما برای رزرو هتل داخلی مورد نظر در هرجای ایران تنها به انجام چند کلیک ساده نیاز دارید. بعد از تایید اطلاعات
      و پرداخت نیز، واچر خود را به صورت آنی و در کوتاه‌ترین زمان از طریق تیم پشتیبانی 24 ساعته ایران هتل آنلاین
      دریافت میکنید.
    </p>
    <h2 class="text-xl font-bold">رزرو هتل با ایران هتل آنلاین در سراسر ایران</h2>
    <p class="text-muted text-xs !font-extralight leading-8 my-3">
      ایران سراسر زیبایی و تمدن است. در هر نقطه از این خاک پهناور، ماجرایی برای کشف و فرصتی برای تجربه‌ی لحظه‌های
      ناب وجود دارد. ایران هتل آنلاین به شما این امکان را میدهد که در هر نقطه از ایران از شمال تا جنوب و از شرق تا
      غرب، در هر شهر و دیاری به رزرو اینترنتی هتل،‌ آن هم با بهترین قیمت بپردازید. ایران هتل آنلاین با پوشش
      حداکثری هتل‌ها در سراسر ایران گام موثری در جهت توسعه صنعت گردشگری کشور برداشته است. برای رزرو ارزان هتل،
      ایران هتل آنلاین بهترین گزینه خواهد بود.
    </p>
    <h2 class="text-xl font-bold">مزایای رزرو اینترنتی هتل از طریق ایران هتل آنلاین
    </h2>
    <p class="text-muted text-xs !font-extralight leading-8 my-3">
      ایران هتل آنلاین با 15 سال سابقه درخشان در عرصه گردشگری، معتبرترین سایت رزرو هتل به صورت آنلاین در سراسر
      ایران باشد. شما با رزرو هتل از طریق ایران هتل آنلاین، بیشترین تخفیف را دریافت کرده و کمترین قیمت را پرداخت
      می‌کنید. پشتیبانی 24 ساعته در 7 روز هفته در اختیار شماست و صفر تا صد مراحل رزرو شما به صورت کاملا آنلاین
      انجام می‌شود. ایران هتل آنلاین با دارا بودن بزرگ‌ترین بانک نظرات میهمانان هتل‌ها، شما را در انتخاب هرچه بهتر
      هتل مورد نظر در شهر مقصد یاری می‌کند.
    </p>
    <h2 class="text-xl font-bold">قیمت رزرو هتل به صورت اینترنتی چه تفاوتی با رزرو حضوری دارد؟
    </h2>
    <p class="text-muted text-xs !font-extralight leading-8 my-3">
      شما با رزرو هتل های داخلی به صورت اینترنتی و از طریق ایران هتل آنلاین شامل تخفیف‌های ویژه می‌شوید. ایران هتل
      کمترین نرخ و بالاترین تخفیف را برای کاربران خود گارانتی می‌کند. شما با رزرو اینترنتی هتل هزینه کمتری را در
      مقایسه با زمانی که به صورت حضوری به هتل مراجعه می‌کنید، پرداخت می‌کنید. علاوه بر این، با رزرو هتل ارزان قبل
      از آغاز سفر، نگرانی از بابت تکمیل شدن ظرفیت هتل محبوب خود نخواهید داشت.
    </p>

  </div>
  <div class="w-full float-left text-left">
    <button class="text-blue-500 flex items-center float-left" (click)="showCollapseInfo = !showCollapseInfo">
      مشاهده {{showCollapseInfo ? 'کمتر' : 'بیشتر'}}
      <i class="{{showCollapseInfo ? 'ico-Up' : 'ico-Down'}}  text-2xl"></i>
    </button>
  </div>

</div>
